import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text } from '../../atoms';

const LetterAvatarWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--elevation-indented);

  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
`;

const StyledText = styled(Text)`
  font-weight: 500;
  font-size: ${({ $size }) => `${$size / 1.7}px`};
  line-height: ${({ $size }) => `${$size}px`};
`;

const LetterAvatar = ({ className = null, name, size = 20, onClick = null }) => (
  <LetterAvatarWrapper className={className} $size={size} onClick={onClick}>
    <StyledText $size={size}>{name?.[0].toUpperCase()}</StyledText>
  </LetterAvatarWrapper>
);

LetterAvatar.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  onClick: PropTypes.func
};

export { LetterAvatar };
